export default __webpack_public_path__ + "static/media/float.f644e99e.svg";